export const pStateToReduxServiceItem = (state) => {
  return state
}
